export default __webpack_public_path__ + "static/media/lapida.20088157.svg";